import { reactive } from "vue";

export const store = reactive({
    user_id: '',
    user: '',
    userRole: '',
    userType: '',
    userStatus: ''
})